// extracted by mini-css-extract-plugin
export default {"migrationWarningIcon":"LbAl8FvZPq7auvj4kDoJ"};